// extracted by mini-css-extract-plugin
export default {"RegionInlineSearch":"ljqxvoAr","dropdown":"B9mb3OUq","wrapper":"HyCTnli1","item":"cPnmQfVV","stringInput":"FNu0wpk5"};